@if (this.showSuccessOverlay == 'loading') {
  <div  style="background: transparent; min-height: 50px; overflow: hidden;">
    @if (this.showSuccessOverlay == 'loading') {
      <div>
        <div class='loading-spinner-background'>&nbsp;</div>
        <div class='loading-spinner'></div>
      </div>
    }
  </div>
}
<!-- should not be called -->
@if ( false && this.showSuccessOverlay !== 'loading') {
  <div  style="background: white; min-height: 100px; overflow: hidden; border: 5px solid grey;padding: 20px">
    @if (this.showSuccessOverlay == 'success') {
      <div>
        <input type="image" src="../../assets/images/done-icon.png" (click)="closeDialog()" style="height: 50px">
        <div> Your changes have been saved successfully</div>
      </div>
    }
    @if (this.showSuccessOverlay == 'error') {
      <div>
        <img  src="../../assets/images/warning.png"  style=" height: 50px">
        <div> You're attempting to edit information that was recently changed.<br/>
        Please refresh page to see latest changes</div><br/>
        <button class="btn-action btn-action-text btn-action-primary" (click)="refreshData()">Refresh</button>
      </div>
    }
    @if (this.showSuccessOverlay == 'error-system') {
      <div>
        <img  src="../../assets/images/warning.png"  style=" height: 50px">
        <div> There was an error processing your request<br/>
        Please refresh page and try again</div><br/>
        <button class="btn-action btn-action-text btn-action-primary" (click)="refreshData()">Refresh</button>
      </div>
    }
  </div>
}


